export default [
  {
    id: 6,
    user_id: 24,
    name: "رضا احمدی",
    amount: 2 * Math.pow(10, 6),
    operate: 2,
    created_at: "۱۴۰۰/۰۹/۰۵ ۲۱:۳۱:۳۸",
  },
  {
    id: 5,
    user_id: 5,
    name: "یاسین سعیدی",
    amount: 2 * Math.pow(10, 6),
    operate: 1,
    created_at: "۱۴۰۰/۰۹/۰۵ ۲۱:۲۹:۳۸",
  },
  {
    id: 4,
    user_id: 24,
    name: "رضا احمدی",
    amount: 4 * Math.pow(10, 6),
    operate: 2,
    created_at: "۱۴۰۰/۰۹/۰۲ ۱۴:۳۵:۰۶",
  },
  {
    id: 3,
    user_id: 4,
    name: "مرجان رسولی",
    amount: 4 * Math.pow(10, 6),
    operate: 1,
    created_at: "۱۴۰۰/۰۹/۰۲ ۱۴:۳۴:۰۶",
  },
  {
    id: 2,
    user_id: 24,
    name: "رضا احمدی",
    amount: 7 * Math.pow(10, 7),
    operate: 2,
    created_at: "۱۴۰۰/۰۸/۲۹ ۱۴:۳۵:۰۶",
  },
  {
    id: 1,
    user_id: 4,
    name: "مرجان رسولی",
    amount: 7 * Math.pow(10, 7),
    operate: 1,
    created_at: "۱۴۰۰/۰۸/۲۹ ۱۴:۳۴:۰۶",
  },
];
